import React, { useCallback, useEffect, useState } from 'react';

import IdleLogo from '../../../assets/images/idle-logo.svg';

import NetworkStatus from '../NetworkStatus';

const LoadingWrapper = ({ interactive = true, fullscreen = false }) => {
  const [showReloadButton, setShowReloadButton] = useState(false);
  const [showNetworkStatus, setShowNetworkStatus] = useState(false);

  useEffect(() => {
    if (!interactive) return;

    const network = setTimeout(() => setShowNetworkStatus(true), 1000);
    const reload = setTimeout(() => setShowReloadButton(true), 3000);

    return () => {
      clearTimeout(reload);
      clearTimeout(network);
    };
  }, [interactive]);

  const handleReload = useCallback(() => {
    window.dispatchEvent(new CustomEvent('output:reload', { detail: { source: 'loading-wrapper', reason: 'manual-reload-button' } }));
  }, []);

  return (
    <div className={`flex flex-col items-center justify-center px-4 ${fullscreen ? 'h-dvh w-dvw' : 'size-full'}`} data-app-region="drag">
      <div className="flex w-full max-w-112 flex-col items-center justify-start gap-6 md:gap-10">
        <div className="text-black dark:text-white">
          <IdleLogo className="h-8 w-auto" />
        </div>
        {interactive && (
          <div className="flex h-25 w-full max-w-112 flex-col items-center justify-start gap-4">
            {showReloadButton && (
              <button
                onClick={handleReload}
                className="animate-fade-in-delayed cursor-pointer rounded-xl bg-black px-6 py-3.5 text-cursed font-medium text-white hover:bg-neutral-800 md:px-10 dark:bg-white dark:text-black dark:hover:bg-neutral-100"
                data-app-region="none"
              >
                Reload app
              </button>
            )}

            {showNetworkStatus && <NetworkStatus />}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingWrapper;
